import { app } from "@microsoft/teams-js";
import { ArcElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import { TFunction } from "i18next";
import * as AdaptiveCards from "adaptivecards";
import * as React from 'react';
import { Bar, Doughnut } from "react-chartjs-2";
import { withTranslation, WithTranslation } from "react-i18next";
import { exportNotification, getCardTypes, getSentNotification, getTemplate } from "../../apis/messageListApi";
import { formatDate, formatDuration, formatNumber } from "../../i18n";
import './singleMessageReport.scss';
import { ICardTypeMetadata } from '../../cardTypes';
import { ITemplate } from '../../templateModel'
import { getInitAdaptiveCard, setCard } from "../AdaptiveCard/adaptiveCard";
import { markDownToHtml } from '../../helpers/formattingHelper'
import { Button, Spinner, Persona, Link } from "@fluentui/react-components"
import { ArrowDownload24Filled, ArrowLeft24Filled } from "@fluentui/react-icons"
import { INewsletter, INewsSection, prepareNewsTemplateCard } from "../NewMessage/newsTemplate";

interface MessageViewTimes {
    date: string;
    time: string;
}

interface IState {
    notification: any[];
    duration: string;
    summary: any;
    loading: boolean;
    pageNumber: number;
    pageToken: any[];
    messageViewTimes: MessageViewTimes[];
    message: IMessage;
    cardTypes: { [key: string]: ICardTypeMetadata };
    teamId?: string;
    template: any;
}

interface IMessageError {
    message: string;
    count: number;
}

export interface IAction {
    title: string,
    link: string
}

export interface IMessage {
    id: string;
    title: string;
    acknowledgements?: string;
    reactions?: string;
    responses?: string;
    succeeded?: string;
    failed?: string;
    unknown?: string;
    sentDate?: string;
    imageLink?: string;
    videoLink?: string;
    videoImageLink?: string;
    summary?: string;
    author?: string;
    updateType: string;
    buttonLink?: string;
    buttonTitle?: string;
    teamNames?: string[];
    rosterNames?: string[];
    groupNames?: string[];
    userNames?: string[];
    allUsers?: boolean;
    sendingStartedDate?: string;
    sendingDuration?: string;
    errorMessage?: string;
    warningMessage?: string;
    canDownload?: boolean;
    sendingCompleted?: boolean;
    isScheduled?: boolean;
    scheduledDate?: string;
    sender?: string,
    creator?: string,
    usersListFile?: string;
    actions: IAction[];
    messageErrors: IMessageError[];
    newsletterHeader?: string;
}

export interface ISingleMessageReportProps extends WithTranslation {
    notification: any;
    goBack: any;
}

class SingleMessageReport extends React.Component<ISingleMessageReportProps, IState> {
    private card: any;
    readonly localize: TFunction;
    private initMessage = {
        id: "",
        title: "",
        updateType: "",
        actions: [],
        messageErrors: []
    };
    constructor(props: ISingleMessageReportProps) {
        super(props);
        this.localize = this.props.t;
        this.card = getInitAdaptiveCard(this.props.t);
        this.state = {
            notification: this.props.notification,
            summary: null,
            duration: "",
            loading: true,
            pageNumber: 1,
            pageToken: [{ nextPartitionKey: "", nextRowKey: "" }],
            messageViewTimes: [],
            message: this.initMessage,
            cardTypes: {},
            teamId: '',
            template: null,
        }
    }

    private getItem = async (response: any): Promise<IMessage> => {
        try {
            response.data.sendingDuration = formatDuration(response.data.sendingStartedDate, response.data.sentDate);
            response.data.sendingStartedDate = formatDate(response.data.sendingStartedDate);
            response.data.sentDate = formatDate(response.data.sentDate);
            response.data.succeeded = formatNumber(response.data.succeeded);
            response.data.failed = formatNumber(response.data.failed);
            response.data.unknown = response.data.unknown && formatNumber(response.data.unknown);
            this.setState({
                message: response.data
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    private getTemplate = async (id: string): Promise<ITemplate> => {
        try {
            let response = await getTemplate(id);
            const templateData = response.data;

            const cardMetadata = this.state.cardTypes[templateData.id]

            var newTemplate: ITemplate = {
                id: templateData.id,
                templateName: templateData.templateName ? templateData.templateName : cardMetadata.clientTitle,
                indexOrder: templateData.indexOrder,
                bannerUrl: templateData.bannerUrl ? templateData.bannerUrl : `/Content/${cardMetadata.logo}`,
                backgroundColorUrl: templateData.backgroundColorUrl ? templateData.backgroundColorUrl : `/Content/colors/${cardMetadata.color}.png`,
                textColor: templateData.textColor,
                authorGroups: templateData.authorGroups,
                emailOffSet: templateData.emailOffSet,
                allowSendAll: templateData.allowSendAll,
                isIncidentSummary: templateData.isIncidentSummary,
                elements: templateData.elements,
            }
            this.setState({
                template: newTemplate
            });
            return newTemplate;
        } catch (error) {
            throw error;
        }
    }

    private onExport = async () => {
        let spanner = document.getElementsByClassName("sendingLoader");
        spanner[0].classList.remove("hiddenLoader");
        let payload = {
            id: this.state.message.id,
            teamId: this.state.teamId
        };

        console.log(payload);
        await exportNotification(payload).then(() => {
            //this.setState({ page: "SuccessPage" });
            spanner[0].classList.add("hiddenLoader");
        }).catch(() => {
            //this.setState({ page: "ErrorPage" });
            spanner[0].classList.add("hiddenLoader");
        });
    }

    public async componentDidMount() {
        await app.initialize();
        app.getContext().then((context: app.Context) => {
            this.setState({
                teamId: context.team?.internalId,
            });
        });

        const notificationSummaryResponse = await getSentNotification(this.props.notification.id, true);

        const summaryData = notificationSummaryResponse.data;

        var cardTypesResponse = await getCardTypes();
        this.setState({ cardTypes: cardTypesResponse.data });

        this.setState({
            duration: formatDuration(summaryData.sendingStartedDate, summaryData.sentDate),
            summary: summaryData,
            loading: false,
        }, async () => {

            if (this.props.notification.id) {
                var message = await this.getItem(notificationSummaryResponse);
                var template = await this.getTemplate(message.updateType);
                console.log(message)
                console.log(template)
                var card;
                if (message.updateType === "010") {
                    card = {};
                }
                else if (message.updateType === "999") {
                    const separator = "%%||";

                    const titles = message.title.split(separator);
                    const imageLinks = message.imageLink?.split(separator) || [];;
                    const summaries = message.summary?.split(separator) || [];

                    var sections = titles.map((title, index) => ({
                        title: title,
                        summary: summaries[index],
                        imageUrl: imageLinks[index]
                    } as INewsSection))

                    var letter = {
                        sections: sections,
                        header: message.newsletterHeader,
                        actions: message.actions
                    } as INewsletter

                    card = prepareNewsTemplateCard(letter)
                } else {
                    setCard(this.localize, this.card, this.state.template.elements, this.state.template.textColor, this.state.message, this.state.template)
                    card = this.card
                }

                let adaptiveCard = new AdaptiveCards.AdaptiveCard();
                AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (text, result) {
                    result.outputHtml = markDownToHtml(text);
                    result.didProcess = true;
                };

                adaptiveCard.parse(card);
                let renderedCard = adaptiveCard.render() as HTMLElement;
                document.getElementsByClassName('adaptiveCardContainer')[0]?.appendChild(renderedCard);
                let link = message.buttonLink;
                adaptiveCard.onExecuteAction = function (action) { window.open(link, '_blank'); }
            }
        });
    }

    public render(): JSX.Element {
        ChartJS.register(
            CategoryScale,
            LinearScale,
            PointElement,
            LineElement,
            ArcElement,
            Tooltip,
            Title,
            Legend,
        );

        if (this.state.loading) {
            return (
                <div className="calendar-loader">
                    <Spinner />
                </div>
            )
        } else {
            const createdDate = formatDate(this.state.summary.createdDateTime);
            const startedSendingDate = formatDate(this.state.summary.sendingStartedDate);
            const sentDate = formatDate(this.state.summary.sentDate);
            const notViewedCount = this.state.summary.succeeded - this.state.summary.views;

            const doughnutOptions = {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'top' as const,
                    },
                    title: {
                        display: true,
                        text: 'Failed Messages'
                    }
                }
            }

            const doughnutData = {
                labels: this.state.message.messageErrors.map((e) => e.message),
                datasets: [
                    {
                        label: 'Total',
                        data: this.state.message.messageErrors.map((e) => e.count),
                        borderColor: ['#02a5f2', '#8fce00', '#F39800'],
                        backgroundColor: ['#02a5f2', '#8fce00', '#F39800'],
                    }
                ],
            };

            const barOptions = {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: 'Message Status'
                    }
                }
            }

            const barData = {
                labels: ['Sent', 'Views', 'Clicks'],
                datasets: [
                    {
                        data: [this.state.summary.succeeded, this.state.summary.views, this.state.summary.buttonClicks],
                        borderColor: ['#02a5f2', '#8fce00', '#F39800'],
                        backgroundColor: ['#02a5f2', '#8fce00', '#F39800'],
                        barThickness: 50,
                    },
                ],
            };


            // let scatterArray: Object[] = [];
            // if (this.state.messageViewTimes.length > 0) {

            //     this.state.messageViewTimes.forEach((e) => {
            //         scatterArray.push({"x": new Date(e.date), "y": new Date(e.time)})
            //     })
            // }

            // const scatterOptions = {
            //     maintainAspectRatio: false,
            //     plugins: {
            //         legend: {
            //             display: true
            //         },
            //         title: {
            //             text: "Message Timeline of Views",
            //             display: true,
            //         }
            //     },
            //     scales: {
            //         x:{
            //             time: {
            //                 unit: "day"
            //             },
            //             title: {
            //                 display: true,
            //                 text: "Date Viewed",
            //             }        
            //         },
            //         y: {
            //             title: {
            //                 display: true,
            //                 text: "Time Viewed",
            //             }                        
            //         },
            //     },
            // };

            // const scatterData = {
            //     datasets: [
            //         {
            //         label: 'Message Views by Time',
            //         data: scatterArray,
            //         backgroundColor: 'rgba(255, 99, 132, 1)',
            //         },
            //     ],
            // };

            return (
                <div className="report-container">
                    <div style={{ marginBottom: "20px" }} >
                        <Button className="report-back" icon={<ArrowLeft24Filled />} onClick={this.props.goBack} appearance="secondary">Back</Button>
                        <h2 id="notificationSummaryHeader" style={{ display: "inline", verticalAlign: "middle", marginLeft: "20px" }} >Notification Summary</h2>
                        <div className="buttonContainer" style={{ display: "inline-block", float: "right" }} >
                            <Spinner id="sendingLoader" className="hiddenLoader sendingLoader" size="extra-small" label={this.localize("ExportLabel")} labelPosition="after" />
                            <Button icon={<ArrowDownload24Filled />} disabled={!this.state.message.canDownload || !this.state.message.sendingCompleted} id="exportBtn" onClick={this.onExport} appearance="secondary">Export</Button>
                        </div>
                    </div>
                    {this.state.summary &&
                        <>
                            <div className="report-charts">
                                <div className="top-charts">
                                    <div className="chart">
                                        <div className="adaptiveCardContainer" style={{ maxWidth: "450px", border: "1px solid #c7c7c7" }} >
                                        </div>
                                        {/*    <Doughnut*/}
                                        {/*        options={viewOptions}*/}
                                        {/*        data={viewData}*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        {/*<div className="chart">*/}
                                        {/*    <Doughnut*/}
                                        {/*        options={successOptions}*/}
                                        {/*        data={successData}*/}
                                        {/*    />*/}
                                    </div>
                                    <div className="chart" style={{ border: "1px solid #c7c7c7", background: "white", padding: "15px", marginLeft: "10px", minWidth: "448px" }} >
                                        <Bar
                                            options={barOptions}
                                            data={barData}
                                        />
                                    </div>
                                    {
                                        this.state.summary.failed > 0 &&
                                        <div className="chart" style={{ border: "1px solid #c7c7c7", background: "white", padding: "15px", marginLeft: "10px", minWidth: "448px" }}>
                                            <Doughnut
                                                options={doughnutOptions}
                                                data={doughnutData}
                                            />
                                        </div>
                                    }
                                </div>
                                <div className="bottom-chart chart">
                                    {/* <Scatter 
                                        options={scatterOptions}
                                        data={scatterData}
                                    /> */}
                                </div>
                            </div>
                            <hr />
                            <div className="report-stats">
                                {/*<div className="report-stats-column">*/}
                                {/*<div className="adaptiveCardContainer" style={{ maxWidth: "450px", border: "1px solid #c7c7c7" }} >*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className="report-stats-column">
                                    <div className="report-stat"><h3>Title: </h3>{this.state.summary.newsletterHeader || this.state.summary.title}</div>
                                    <div className="report-stat"><h3>Created By: </h3> {this.state.summary.creator}</div>
                                    <div className="report-stat"><h3>Created By UPN: </h3>{this.state.summary.creatorUpn}</div>
                                    <div className="report-stat"><h3>Created Date: </h3>{createdDate}</div>
                                    <div className="report-stat"><h3>Sent By: </h3>{this.state.summary.sender}</div>
                                    <div className="report-stat"><h3>Started Sending Date: </h3>{startedSendingDate}</div>
                                    <div className="report-stat"><h3>Completed Sent Date: </h3>{sentDate}</div>
                                    <div className="report-stat"><h3>Duration: </h3>{this.state.duration}</div>
                                    <div className="report-stat">{this.renderAudienceSelection()}</div>
                                </div>
                                <div className="report-stats-column">
                                    <div className="report-stat"><h3>Succeeded: </h3>{this.state.summary.succeeded}</div>
                                    <div className="report-stat"><h3>Failed: </h3>{this.state.summary.failed}</div>
                                    {this.state.summary.warningMessage &&
                                        <div className="report-stat"><h3>Failed Reason: </h3>{this.state.summary.warningMessage}</div>
                                    }
                                    <div className="report-stat"><h3>Total Views: </h3>{this.state.summary.views}</div>
                                    <div className="report-stat"><h3>Popularity: </h3>{ (this.state.summary.views / this.state.summary.succeeded * 100).toFixed(2) }%</div>
                                    <div className="report-stat"><h3>Total Reactions: </h3>{this.state.summary.reactionCount}</div>
                                    <div className="report-stat"><h3>Total In-line Link Clicks: </h3>{this.state.summary.inlineLinkClicks}</div>
                                    <div className="report-stat"><h3>Total Button Clicks: </h3>{this.state.summary.buttonClicks}</div>
                                    <div className="report-stat"><h3>Is Important: </h3>{this.state.summary.isImportant.toString()}</div>
                                    <div className="report-stat"><h3>Was Scheduled: </h3>{this.state.summary.isScheduled.toString()}</div>

                                </div>
                                <div className="report-stats-column">

                                </div>
                            </div>

                        </>
                    }
                </div>
            )
        }
    }

    private getItemList = (items: string[]): JSX.Element => (<ul className='audienceList'>
        {items.map(x => (
            <li key={x}><Persona name={x} textAlignment="center" avatar={{ color: "colorful", "aria-hidden": true }} /></li>
        ))}
    </ul>)

    private renderAudienceSelection = () => {
        let recipents: JSX.Element[] = []
        if (this.state.summary.teamNames && this.state.summary.teamNames.length > 0) {
            recipents.push(
                <div key="teamNames"> <h3>{this.localize("TeamsLabel")}</h3>
                    {this.getItemList(this.state.summary.teamNames)}
                </div>
            );
        }
        if (this.state.summary.rosterNames && this.state.summary.rosterNames.length > 0) {
            recipents.push(
                <div key="rosterNames"> <h3>{this.localize("TeamsMembersLabel")}</h3>
                    {this.getItemList(this.state.summary.rosterNames)}
                </div>);
        }
        if (this.state.summary.groupNames && this.state.summary.groupNames.length > 0) {
            recipents.push(
                <div key="groupNames" > <h3>{this.localize("GroupsMembersLabel")}</h3>
                    {this.getItemList(this.state.summary.groupNames)}
                </div>);
        }
        if (this.state.summary.usersListFile || this.state.summary.userNames && this.state.summary.userNames.length > 0) {
            recipents.push(
                <div key="userNames" > <h3>{"User(s): "}</h3>
                    {this.state.summary.usersListFile && (<Link target="_blank" href={"/api/Content/getUsersAudience?fileName=" + this.state.summary.usersListFile} inline>{this.state.summary.usersListFile}</Link>)}
                    {this.getItemList(this.state.summary.userNames!)}
                </div>);
        }
        if (this.state.summary.allUsers) {
            recipents.push(
                <div>
                    <h3>{this.localize("SendToAllUsers")}</h3>
                </div>);
        } else {
            recipents.push(<div></div>);
        }

        return (<>{recipents}</>)
    }

}

const SingleMessageReportWithTranslation = withTranslation()(SingleMessageReport);
export default SingleMessageReportWithTranslation;